import React from 'react'
import { useTranslation } from 'react-i18next'
import PlaceholderPage from '../PlaceholderPage'

function ContactPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('contact_us') || 'Contact us'} />
}

export default ContactPage
